import { TextDescription, TextTitle } from "components/Texts";

import { OpportunityBar } from "components/bar";
import React from "react";
import Separator from "../Separator";
import TextSubscript from "../TextSubscript";
import colors from "styles/colors";
import formatMoney from "../../modules/utils/formatMoney";
import formatNumber from "modules/utils/formatNumber";
import getMax from "services/getMaxJsonArray";
import styled from "styled-components";
import useCurrency from "modules/utils/useCurrency";
import { useTranslation } from "react-i18next";

const CampaignZone = ({ data = [], example }) => {
  //eslint-disable-next-line no-unused-vars
  const [t] = useTranslation();
  const maxClick = getMax(data, "wClick").wClick + getMax(data, "moreClick").moreClick;
  const currency = useCurrency();
  return (
    <StyledContainer>
      {example && <TextTitle size="12px">{t("__example")}</TextTitle>}
      {data.map((item, index) => {
        let width = ((item.wClick + item.moreClick) / maxClick) * 50 + 50;
        console.log("item.moreConversion", item.moreConversion);
        return (
          <StyledItem key={index} example={example}>
            <TextDescription size="10px">{t("__suggestion_campaing")}</TextDescription>
            <TextTitle size="14px" breakAll>
              {`${item.campaign}`}
            </TextTitle>
            <Separator margin="3px 0" />
            <TextSubscript
              valueText={`${t("__daily_budget")} ${formatMoney(item.dailyCost / 7)}`}
              subscriptText={currency}
              valueSize="14px"
              subscriptSize="10px"
              regular
            />
            <Separator margin="3px 0" />
            <TextDescription size="10px" color={colors.positive}>
              {`${t("__suggestion")}: `}
            </TextDescription>
            <TextSubscript
              valueText={`${t("__raise_daily_budget")} ${formatMoney(item.budgetOpportunity / 7)}`}
              subscriptText={currency}
              valueSize="14px"
              subscriptSize="10px"
              valueColor={colors.positive}
              subscriptColor={colors.positive}
              regular
            />
            <Separator margin="3px 0" />
            <OpportunityBar
              height={20}
              width={width || 100}
              value1={item.moreConversion ? item.conversions : item.clicks}
              value2={item.moreConversion ? item.moreConversion : item.moreClick}
              text={
                item.moreConversion
                  ? `${t("__suggestion_conversion")}: ${formatNumber(item.conversions)}`
                  : `${t("__suggestion_click")}: ${formatNumber(item.clicks)}`
              }
            />
          </StyledItem>
        );
      })}
    </StyledContainer>
  );
};

export default CampaignZone;

const StyledContainer = styled.div`
  padding: 0 16px;
  margin: 24px 0 0;
`;

const StyledItem = styled.div.attrs((props) => ({
  opacity: props.example ? 0.5 : 1,
}))`
  margin: 0 0 32px;
  opacity: ${(props) => props.opacity};
`;
